/* unplugin-vue-components disabled */import { render } from "./BaseBarcode.vue?vue&type=template&id=c4d250aa"
import script from "./BaseBarcode.vue?vue&type=script&lang=js"
export * from "./BaseBarcode.vue?vue&type=script&lang=js"

import "./BaseBarcode.vue?vue&type=style&index=0&id=c4d250aa&lang=scss"
script.render = render

export default script